  import React from "react";
  import { Helmet } from "react-helmet";
  import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
  import Header from "./components/Header";
  import Sidebar from "./components/Sidebar";
  import ProtectedRoute from "./components/ProtectedRoute";
  import GameManagement from "./pages/GameManagement";
  import StatisticsManagement from "./pages/StatisticsManagement";
  import CoinManagement from "./pages/CoinManagement"; // ✅ 알 화폐 관리 추가
  import UserManagement from "./pages/UserManagement";
  import ApiManagement from "./pages/ApiManagement";
  import AgencyManagement from "./pages/AgencyManagement"; // ✅ 추가됨
  import BetManagement from "./pages/BetManagement";
  import MainLayout from "./layouts/MainLayout";
  import "./styles/common.css";
  import LoginPage from "./pages/LoginPage";
  import { UserProvider } from "./context/UserContext";
  import { library } from "@fortawesome/fontawesome-svg-core";
  import { fas } from "@fortawesome/free-solid-svg-icons";
  library.add(fas);
  
  const App = () => {
    return (
      <UserProvider>
          <Router>
            <div id="wrap">
          
              <div id="container-wrap">
            
                <div id="container">
                  <Helmet>
                    <title>Holdem 3</title>
                    <link rel="icon" href="%PUBLIC_URL%/favicon.ico" />
                  </Helmet>
                  <Routes>
                    {/* 로그인 페이지는 레이아웃 없이 따로 */}
                    <Route path="/login" element={<LoginPage />} />
      
                    {/* 나머지 페이지는 MainLayout을 통해 감쌈 */}
                    <Route
                      path="/"
                      element={
                        <ProtectedRoute>
                        <MainLayout />
                        </ProtectedRoute>
                      }
                    >
                      <Route index element={<GameManagement />} />
                      <Route path="index.html" element={<GameManagement />} />
                      <Route path="coin" element={<CoinManagement />} />
                      <Route path="users" element={<UserManagement />} />
                      <Route path="api" element={<ApiManagement />} />
                      <Route path="statistics" element={<StatisticsManagement />} />
                      <Route path="agency" element={<AgencyManagement />} />
                      <Route path="BetManagement" element={<BetManagement />} />
                    </Route>
                  </Routes>
                </div>
              </div>
            </div>
          </Router>
        </UserProvider>
    );
  };

  export default App;
